import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    /**
   * Sets an localstorage
   * @param key
   * @param data
   */
    public setLS(key: string, data: string|number|object|boolean): void {
        localStorage.setItem(key, JSON.stringify(data));
    }

    /**
   * Retrieves an localstorage based on a given key
   * @param key
   * @returns
   */
    public getLS(key: string) {
        return JSON.parse(localStorage.getItem(key));
    }

    /**
   * Removes an localstorage value based on a key
   * @param key
   */
    public removeLS(key: string): void {
        localStorage.removeItem(key);
    }
}
